// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"32":"0c6ccce4","178":"4cecc991"}[chunkId] + ".css";
};